import { render, staticRenderFns } from "./LegacyRoleTable.vue?vue&type=template&id=29122acc&scoped=true&lang=html&"
import script from "./LegacyRoleTable.vue?vue&type=script&lang=js&"
export * from "./LegacyRoleTable.vue?vue&type=script&lang=js&"
import style0 from "./LegacyRoleTable.vue?vue&type=style&index=0&id=29122acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29122acc",
  null
  
)

export default component.exports